<template>
    <div class="upload-file-box">
        <div class="upload-img-box" :style="{width: `${imgWidth}px`, height: `${imgHeight}px`}">
            <span :style="{'font-size': `${imgWidth / 5}px`}">
                <font-awesome-icon icon="fa-solid fa-plus" />
            </span>

            <img
                v-show="showImgFlag"
                :src="modelValue"
                class="preview-img"
                :style="imgStyle"
            />

            <input
                v-if="true != readonlyTag"
                ref="imgFileInputDom"
                @change="uploadSuccess"
                type="file"
                accept="image/*"
                class="hide-input"
            >

            <span
                class="del-btn"
                v-if="true != readonlyTag"
                v-show="showImgFlag"
                @click="clearImg"
            >
                <font-awesome-icon icon="fa-solid fa-circle-xmark" />
            </span>
        </div>

<!--        <div v-show="showBtn" class="btn-box">
            <el-button type="primary" @click="clickBtn" tkey="lang_upload_img">{{i18n.tkey("lang_upload_img")}}</el-button>
        </div>-->

    </div>
</template>

<script setup>
import {ref, onMounted, getCurrentInstance, onBeforeMount, inject, computed, watch} from "vue";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faPlus, faCircleXmark } from '@fortawesome/free-solid-svg-icons'
    import myUtil from "@/util/util";

    library.add(faPlus, faCircleXmark)

    const props = defineProps(['width', "height", 'modelValue', 'useBtn', 'sizeLimit', "readonlyTag", "imgStyle", "autoUpdate"])
    const emit = defineEmits(['update:modelValue', 'selectComplete', 'deleteImg'])

    const { proxy } = getCurrentInstance()

    const i18n = inject("i18n")

    const imgWidth = ref(100)
    const imgHeight = ref(100)
    const showBtn = ref(true)

    // const imgUrl = ref(null)
    let fileInputDom = null

    const showImgFlag = computed(() => {

        return myUtil.isNotEmpty(props.modelValue) && 'deleted' !== props.modelValue
    })
    watch(() => props.width, (newValue, oldValue) => {
      console.log(newValue)
      if(myUtil.isNotEmpty(props.width)){
        imgWidth.value = props.width
      }
    })
    watch(() => props.height, (newValue, oldValue) => {
      if(myUtil.isNotEmpty(props.height)){
        imgHeight.value = props.height
      }
    })
    function uploadSuccess(event) {
        const file = event.target.files[0]
        const reader = new FileReader();

        if (null != props.sizeLimit && file.size / 1024 > props.sizeLimit){
            fileInputDom.value = ""
            emit('update:modelValue', null)
            myUtil.alertWarning(i18n.tkey("lang_file_over_limit"))
            return
        }

        reader.onload = function(e){
            const src = e.target.result
            // imgUrl.value = src
            if (null == props.autoUpdate || props.autoUpdate !== false){
                emit('update:modelValue', src)
            }

            emit('selectComplete', src)
        }
        reader.readAsDataURL(file);
    }

    function clickBtn() {
        fileInputDom.click()
    }

    function clearImg(){
        fileInputDom.value = ""
        emit('update:modelValue', null)
        emit("deleteImg")
    }
    function setImageSize(Width,Height){

      if(myUtil.isNotEmpty(Width)){
        imgWidth.value = Width
      }
      if(myUtil.isNotEmpty(Height)){
        imgHeight.value = Height
      }
    }
    onMounted(() => {
        fileInputDom = proxy.$refs.imgFileInputDom
    })

    onBeforeMount(() => {
        if (null != props.width){
            imgWidth.value = props.width
        }

        if (null != props.height){
            imgHeight.value = props.height
        }

        if (null != props.useBtn){
            showBtn.value = props.useBtn
        }

    })

</script>

<style scoped>
    .upload-file-box {
        display: flex;
      justify-content: center;
    }

    .upload-img-box{
        border: 1px #EBEEF5 solid;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .preview-img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .hide-input {
        opacity: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .btn-box {
        margin-left: 1em;
        display: flex;
        align-items: flex-end;
    }

    .del-btn {
        right: -5px;
        top: -5px;
        position: absolute;
        color: #ff0000;
        line-height: 1;
        font-size: 20px;
        cursor: pointer;
    }
</style>